import { useSelector } from 'react-redux';
import { Button, Flex } from 'antd';

import { selectSelected } from '../../../../common/store/selectionSlice';
import { getInitialFilters } from '../utils/filters';
import { ChatProps } from '../interface/chats.interface';
import { TagsEditor } from './TagsEditor';

export const TableActions = ({
    loading,
    filters,
    updateFilters,
    communityType,
}) => {
    const { selectedRowsItems } = useSelector(selectSelected) as {
        selectedRowsItems: ChatProps[];
    };

    const isRowSelected = selectedRowsItems.length > 0;

    const initialFilters = getInitialFilters(communityType);

    const isInitialChange =
        JSON.stringify(filters) !== JSON.stringify(initialFilters);

    const selectedTags = selectedRowsItems
        .flatMap(item => item.tags ?? [])
        .reduce((acc, tag) => {
            if (!acc.some(t => t.name === tag.name)) {
                acc.push(tag);
            }
            return acc;
        }, []);

    return (
        <Flex justify={'space-between'}>
            {isRowSelected && (
                <TagsEditor
                    selectedTags={selectedTags}
                    count={selectedRowsItems.length}
                />
            )}

            {isInitialChange && (
                <Button
                    loading={loading}
                    onClick={() => updateFilters({ ...initialFilters })}
                    type={'link'}
                >
                    Очистить фильтры
                </Button>
            )}
        </Flex>
    );
};
